module.exports = __webpack_public_path__ + "static/media/marc.101b9dc3.jpg";